var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-form-dialog", {
    ref: "refBaseCard",
    attrs: {
      formOptionNumTemp: "9",
      "is-form": "",
      "is-show-close": "",
      title: _vm.title,
      width: "40%",
    },
    on: { onSendFileList: _vm.onGetFileList, onUploadAfter: _vm.onUploadAfter },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }